<template>
  <div class="max-w-5xl mx-auto mt-20">
    <div class="grid gap-5 md:grid-cols-3">
      <a
        v-for="ad in under_subscription"
        :key="ad.id"
        :href="resolveAdUrl(ad)"
        @click.prevent="handleAdClick(ad, routeName)"
        @mouseover="handleAdHoverStart()"
        @mouseout="handleAdHoverEnd(ad)"
      >
        <img :src="ad.photo" class="md:w-[328px] w-full md:h-[247px]" alt="" />
      </a>
    </div>
  </div>
  <div class="mx-auto mt-5 md:max-w-5xl">
    <div class="grid grid-cols-1 md:gap-5 gap-y-5 md:gap-y-0 md:grid-cols-3">
      <div class="col-span-2">
        <div
          class="flex flex-row items-center h-52 text-white bg-[#007587] rounded-md"
        >
          <div class="p-5">
            <h6 class="pb-1 font-sans text-3xl font-semibold text-start">
              New Projects in Accra
            </h6>
            <p class="font-light text-start">
              New projects, verified by our quality teams.
            </p>
            <a
              href="/new-projects"
              class="flex items-center justify-center p-2 mt-10 text-sm font-semibold text-primary bg-white rounded-md h-[36px] w-44"
            >
              View new projects

              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-5 h-5 ml-1 font-bold stroke-2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div
        class="flex flex-col items-start p-5 text-white rounded-lg bg-secondary justify-evenly h-52"
      >
        <p class="text-sm">Agent Hub:</p>
        <h6 class="my-4 text-2xl font-medium text-left md:my-2">
          List your property with us
        </h6>
        <a
          href="/registration-enquiry"
          class="p-2 text-sm text-secondary bg-white rounded-md shadow-md h-[36px]"
          >Get Started</a
        >
      </div>
    </div>
  </div>
</template>
<script>
import { useAds } from "@/composables/useAds";
import { onMounted } from "vue";
import { useRouter } from "vue-router";
export default {
  setup() {
    const router = useRouter();
    const routeName = router.currentRoute.value.fullPath;
    const {
      under_subscription,
      handleAdClick,
      handleAdHoverStart,
      handleAdHoverEnd,
      resolveAdUrl,
      loadAds,
    } = useAds();

    onMounted(() => {
      loadAds();
    });

    return {
      routeName,
      under_subscription,
      handleAdClick,
      handleAdHoverStart,
      handleAdHoverEnd,
      resolveAdUrl,
    };
  },
};
</script>
